import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
// import DialogContent from '@material-ui/core/DialogContent';
import Fab from '@material-ui/core/Fab';
import CloseIcon from '@material-ui/icons/Close';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';
import styles from './styles';

class PopupJeremyEstrader extends React.Component {
  render() {
    const { data, classes, open, onClose, baseUrl } = this.props;
    const title = parse(data.popup.jeremyEstrader.title);
    const subtitle = parse(data.popup.jeremyEstrader.subtitle);
    const desc = parse(data.popup.jeremyEstrader.desc);
    const imgSrc = `${baseUrl}/popups/${parse(data.popup.jeremyEstrader.imgSrc)}`;
    return (
      <Dialog
        maxWidth="md"
        fullWidth
        scroll="body"
        open={open || false}
        onClose={onClose}
        PaperProps={{
          square: true,
          className: classes.dialogPaper,
        }}
      >
        <Fab color="primary" onClick={onClose} className={classes.closeIcon}>
          <CloseIcon fontSize="large" />
        </Fab>
        <div className={classes.container}>
          <div className={classes.presentation}>
            <DialogTitle disableTypography className={classes.text}>
              <Typography variant="h3">{title}</Typography>
              <TypoFramed frame="black" className={classes.autor} space={false}>
                {subtitle}
              </TypoFramed>
            </DialogTitle>
            <img key="img" src={imgSrc} alt="" className={classes.image} />
          </div>
          <Typography variant="body1" className={classes.desc}>
            {desc}
          </Typography>
        </div>
      </Dialog>
    );
  }
}

PopupJeremyEstrader.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(PopupJeremyEstrader);
